import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { GithubIssues, ExternalLink } from '../../src/components';
import { Label } from '@primer/components';
import { Link } from 'gatsby';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`A great place to start is our issues tracker! Anything without a `}<Label bg="#e99695" mdxType="Label">{`triage`}</Label>{` label has been reviewed by our team and is considered as a valid issue.`}</p>
    <h2>{`Contributing code`}</h2>
    <p>{`When opening a pull request, please make sure you link the respective issue into the Pull Request via the "Linked Issues" section or using closing terms in your description.`}</p>
    <p>{`Please note that as per our `}<ExternalLink href="https://github.com/xedi/sdk-js/blob/master/CONTRIBUTING.md" mdxType="ExternalLink">{`contribution guide`}</ExternalLink>{` pull requests that fail testing, linting or that cause our coverage to decrease significantly may not be accepted.`}</p>
    <h2>{`Non code contributions`}</h2>
    <p>{`If you find a bug, have a feature request, or think there is a better way to do something please open an issue. When you create an issue there will be a number of options. Please select the one most appropriate to your issue. If you find a security vulnerability, please consult our `}<ExternalLink href="https://github.com/xedi/sdk-js/blob/master/SECURITY.md" mdxType="ExternalLink">{`security policy`}</ExternalLink>{`.`}</p>
    <h2>{`Contributing Documentation`}</h2>
    <p>{`Please feel free to add to or fix this documentation. For more information about contributing to this documentation check out the `}<Link to="/documentation/contributing" mdxType="Link">{`Contributing section`}</Link>{`.`}</p>
    <GithubIssues sort="created" direction="asc" renderLabels assignee="none" mdxType="GithubIssues" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      